import { EventResponse } from 'generated';
import { noop } from 'lodash';
import { atom } from 'recoil';

import { EmployeeFunction, ScenarioCostCenter } from 'components/types';

import { CapacityBalanceResponse } from 'RestAPIs/roster/formation';

import { VIEW } from './const';

const uniqueAtomKey = 'Formation_';

export const updateEmploymentSettingsAtom = atom<
  (params: { employmentId: number; excluded: boolean }) => void
>({
  key: `${uniqueAtomKey}_updateEmploymentSettings`,
  default: noop
});

export const updateFlexForecastAtom = atom<boolean>({
  key: `${uniqueAtomKey}_updateFlexForecast`,
  default: false
});

export const showPerFunctionAtom = atom<boolean>({
  key: `${uniqueAtomKey}_showPerFunction`,
  default: false
});

export const grossNetViewAtom = atom<typeof VIEW.NET | typeof VIEW.GROSS>({
  key: `${uniqueAtomKey}_grossNetView`,
  default: VIEW.GROSS
});

export const selectedFunctionAtom = atom<EmployeeFunction | null>({
  key: `${uniqueAtomKey}_selectedFunction`,
  default: null
});

export const selectedCostCenterAtom = atom<ScenarioCostCenter | null>({
  key: `${uniqueAtomKey}_selectedCostCenter`,
  default: null
});

export const capacityBalanceAtom = atom<CapacityBalanceResponse | null>({
  key: `${uniqueAtomKey}_capacityBalance`,
  default: null
});

export const appointmentToCopyAtom = atom<EventResponse | null>({
  key: `${uniqueAtomKey}_appointmentToCopy`,
  default: null
});
